import { useLoader } from 'context/loaderContext';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import { CreateCompany } from 'types/CreateCompany';
import { signupAction } from '../../actions/auth/authActions';
import { RootState } from '../../store';
import { B2B_MenuItems, RouterMap } from '../../utilities/constants';

export const useProvideAuth = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const Loader = useLoader();
  const { user, loading } = useSelector((state: RootState) => state.auth);

  const handleSignup = (signupInfo: CreateCompany) => {
    dispatch(signupAction(signupInfo));
  }

  useEffect(() => {
    if(loading) {
      Loader.showLoader();
    } else {
      Loader.hideLoader();
    }
  }, [loading])

  useEffect(() => {
    if (user?.expertId) {
      history.push(RouterMap[B2B_MenuItems.jobs]);
    }
  }, [user]);


  return [{ handleSignup }];
};
